import React from 'react';
import { Button } from 'reactstrap';

export const SpinnerButton = ({ type, submitting, title, disabled, block, color, onClick, className }) => (
    <Button
        color={color}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        type="button"
        className={'px-4 ' + className}
        disabled={disabled}
        block={window.innerWidth < 450 || block}
        onClick={() => !submitting && onClick()}>
        {submitting ? <i className="fa fa-spinner fa-spin" /> : title}
    </Button>
);
